import React from "react";
import theme from "theme";
import { Theme, Box, Section, Span, Text } from "@quarkly/widgets";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import IndexesBlurb from "./index_blurb";
import IndexSolarGreenhouse from "./index_solargreenhouse";
import IndexWindTurbine from "./index_windturbine";
import IndexThermalStorage from "./index_thermalstorage";
import IndexesLatestArticles from "./index_latestarticles";
import IndexesNotableArticles from "./index_notablearticles";
import Sponsors from "./index_sponsors";
import Collaborators from "./index_collabs";

// local images

// const font_base_small = "--fontFamily-googleRubik";
// const font_base_small_old = "Varta"; // just for reference
// const font_base_large_old = "--fontFamily-googleAlegreyaSans"; // just for reference

export default () => {
  return (
    <Theme theme={theme}>
      <GlobalQuarklyPageStyles pageUrl={"index"} />
      <Components.CombinedHelmetNHeader />
      <Section
        padding="36px 0 60px 0"
        quarkly-title="Section_ClubTitle"
        md-padding="16px 0 30px 0"
        background="rgba(0, 0, 0, 0) url() 0% 0% /auto repeat scroll padding-box"
      >
        <Override
          slot="SectionContent"
          flex-direction="row"
          md-flex-wrap="wrap"
          align-items="center"
          display="flex"
          justify-content="center"
        />
        <Text
          font="--headline1"
          color="--light"
          margin="0px 0px 0px 0px"
          lg-font="normal 700 50px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          md-font="normal 700 40px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          md-margin="0px 0px 24px 0px"
          text-align="center"
        >
          Renewable Energy Design
          <br />
          <Span
            font-weight="normal"
            overflow-wrap="normal"
            word-break="normal"
            white-space="normal"
            text-indent="0"
            text-overflow="clip"
            hyphens="manual"
            user-select="auto"
            pointer-events="auto"
          >
            UAlberta Student Club
          </Span>
        </Text>
      </Section>
      <IndexesBlurb />
      <Section
        padding="60px 0 40px 0"
        quarkly-title="Section_MajorProjects_Title"
      >
        <Box
          md-width="100%"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="100%"
          display="flex"
          align-self="auto"
          flex="1 1 0%"
          align-items="center"
          flex-direction="column"
          justify-content="center"
          flex-wrap="no-wrap"
        >
          <Text
            margin="0px 0px 40px 0px"
            color="--light"
            font="--headline2"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-margin="0px 0px 16px 0px"
          >
            Our Major Projects
          </Text>
          <Text
            color="--light"
            font="--base"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            margin="0px 0px 0px 0px"
            text-align="left"
          >
            Currently, our club has three main projects:
          </Text>
        </Box>
      </Section>
      <IndexSolarGreenhouse />
      <IndexWindTurbine />
      <IndexThermalStorage />
      <IndexesLatestArticles />
      <IndexesNotableArticles />
      <Sponsors />
      <Collaborators />
      <Components.CustomFooter />
      <RawHtml>
        <style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
          {
            ":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"
          }
        </style>
      </RawHtml>
    </Theme>
  );
};
